import React, { Component, Fragment } from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';

export class VerCampaignPromotionsDatatable extends Component {
    constructor(props) {
        super(props)
        this.state = {
            checkedValues: [],
            myData: this.props.myData
        }
    }

    componentDidUpdate(prevProps, prevState){
        if(prevProps.myData != prevState.myData){
            this.setState({
                myData: prevProps.myData
            })
        }
    }

    Capitalize(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    deletePromotion(row){
        this.props.deletePromotion(row);
    }

    render() {
        const { pageSize, myClass, multiSelectOption, pagination } = this.props;
        const { myData } = this.state;

        const columns = [];
        for (var key in myData[0]) {
            if(key === "Título" || key === "Estado" || key === "Clicks" || key === "Vigencia"){
                columns.push({
                    Header: <b>{this.Capitalize(key.toString())}</b>,
                    accessor: key,
                    Cell: (props) => <div dangerouslySetInnerHTML={{__html: props.value}} />,
                    style: {
                        textAlign: 'center'
                    }
                });
            }
        }

        columns.push({
            Header: <b>Acción</b>,
            id: 'actions',
            accessor: str => "actions",
            Cell: (row) => (
                <div>
                    <Link to={`${process.env.PUBLIC_URL}/edit-campaign-promotion/${row.original.id}`} title="Editar">
                        <i className="fa fa-pencil" style={{ width: 35, fontSize: 20, padding: 11, color:'rgb(40, 167, 69)' }}></i>
                    </Link>
                    <Link to={`#`} title="Eliminar" onClick={() => {
                        Swal.fire({
                            title: 'Confirmar',
                            text: '¿Desea eliminar la promoción "'+ row.original.Título +'"?',
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#d33',
                            confirmButtonText: 'Confirmar',
                            cancelButtonText: 'Cancelar'
                         }).then((result) => {
                            if(result.value){
                                let data = myData;
                                data.splice(row.index, 1);
                                this.setState({ myData: data });
                                this.deletePromotion(row)
                           }
                         })
                    }}>
                        <i className="fa fa-trash" style={{ width: 35, fontSize: 20, padding: 11, color: '#e4566e' }}></i>
                    </Link>
                </div>
            ),
            style: {
                textAlign: 'center'
            },
            sortable: false
        });

        return (
            <Fragment>
                <ReactTable
                    data={myData}
                    columns={columns}
                    defaultPageSize={pageSize}
                    className={myClass}
                    showPagination={pagination}
                />
                <ToastContainer />
            </Fragment>
        )
    }
}

export default VerCampaignPromotionsDatatable
